import { createContext, Dispatch, useContext } from "react";
import { IUser } from "@/core/api/model/user.ts";
import { ensureExhaustive, noop } from "@/core/utils/helper.ts";
import { ApplicationError } from "@/core/api/model/error.ts";

export enum AppActionTypes {
    SET_USER = "SET_USER",
    SET_ERROR = "SET_ERROR",
}

interface IAppState {
    /**
     * User info object
     */
    user: IUser | null;
    error: ApplicationError;
}

interface SetUserAction {
    type: AppActionTypes.SET_USER;
    payload: IUser | null;
}

interface SetErrorAction {
    type: AppActionTypes.SET_ERROR;
    payload: ApplicationError;
}

type IAppActions = SetUserAction | SetErrorAction;

interface IAppContext {
    state: IAppState;
    dispatch: Dispatch<IAppActions>;
}

const AppContext = createContext<IAppContext>({
    state: {
        user: null,
        error: ApplicationError.NONE,
    },
    dispatch: noop,
});
export default AppContext;

export function appReducer(state: IAppState, action: IAppActions): IAppState {
    const type = action.type;
    let newState: IAppState;
    switch (type) {
        case AppActionTypes.SET_USER:
            newState = { ...state, user: action.payload };
            break;
        case AppActionTypes.SET_ERROR:
            newState = { ...state, error: action.payload };
            break;
        default:
            ensureExhaustive(type);
    }
    return newState;
}

export function useAppState(): IAppState {
    const { state } = useContext(AppContext);
    return state;
}

/**
 * Custom hook for user
 */
export function useUser(): IUser | null {
    const { state } = useContext(AppContext);
    return state.user;
}
